import React, { useState, useEffect } from "react";
import CentroArcade from "./dashboard/arcade/CentroArcade";

export default function Layout({ children }) {
  const [festividad, setFestividad] = useState({ id: "", nombre: "", icono: "", claseCSS: "" });
  const [mostrarInsignia, setMostrarInsignia] = useState(true);
  const [iniciarDesvanecimiento, setIniciarDesvanecimiento] = useState(false);

  useEffect(() => {
    // Detección automática de festividades durante todo el año
    const verificarFestividad = () => {
      const hoy = new Date();
      const mes = hoy.getMonth() + 1;
      const dia = hoy.getDate();

      if (mes === 10) {
        setFestividad({ id: "halloween", nombre: "Temporada de Halloween", icono: "🎃", claseCSS: "festivity-halloween" });
      } else if (mes === 12 || (mes === 1 && dia <= 6)) {
        setFestividad({ id: "navidad", nombre: "Navidad y Fiestas Decembrinas", icono: "🎄", claseCSS: "festivity-navidad" });
      } else if (mes === 9) {
        setFestividad({ id: "amor", nombre: "Mes de Amor y Amistad", icono: "💖", claseCSS: "festivity-amor" });
      } else if (mes === 1 && dia > 6) {
        setFestividad({ id: "anionuevo", nombre: "Próspero Año Nuevo", icono: "🎉", claseCSS: "festivity-anionuevo" });
      } else {
        setFestividad({ id: "", nombre: "", icono: "", claseCSS: "" });
      }
    };

    verificarFestividad();

    // Insignia visible por 4.5 segundos antes de desvanecerse de forma fluida
    const timerFade = setTimeout(() => {
      setIniciarDesvanecimiento(true);
    }, 4500);

    const timerHide = setTimeout(() => {
      setMostrarInsignia(false);
    }, 5200);

    return () => {
      clearTimeout(timerFade);
      clearTimeout(timerHide);
    };
  }, []);

  return (
    // Ya no inyectamos theme-dark aquí, Tailwind lo maneja globalmente desde App.jsx con la clase 'dark' en el html.
    // Solo inyectamos la clase de la festividad actual.
    <div className={`min-h-screen w-full relative overflow-x-hidden flex flex-col items-center transition-colors duration-700 ${festividad.claseCSS}`}>
      
      {/* INSIGNIA FLOTANTE (Dura 5 segundos y se desvanece con animación) */}
      {festividad.id && mostrarInsignia && (
        <div className={`fixed top-4 right-4 z-[9999] hidden sm:flex items-center gap-2.5 bg-white/90 dark:bg-slate-900/95 backdrop-blur-2xl px-6 py-3 rounded-full border border-slate-200 dark:border-slate-700 shadow-2xl transition-all duration-700 ${iniciarDesvanecimiento ? 'opacity-0 scale-95 translate-y-[-10px]' : 'opacity-100 scale-100 translate-y-0'}`}>
          <span className="text-2xl animate-bounce">{festividad.icono}</span>
          <div className="flex flex-col">
            <span className="text-xs font-black uppercase tracking-wider text-slate-900 dark:text-white">{festividad.nombre}</span>
            <span className="text-[9px] font-bold text-slate-500">Modo Estacional Automático </span>
          </div>
        </div>
      )}

      {/* Contenedor principal de la app */}
      <main className="w-full flex-1 flex flex-col relative z-10 animate-fade-in">
        {children}
      </main>

      {/* Botón flotante del Arcade */}
      <div className="relative z-50">
        <CentroArcade />
      </div>
    </div>
  );
}